export const animationState: IAnimationState = {
  isRunning: false,
  showHud: false,
  origin: [0, 0, 0],
  storyLineIndex: -1,
};
